// extracted by mini-css-extract-plugin
export default {"titleBtnBox":"euxzLU1lEs_6CqyyPcWJ"};